module.exports = __webpack_public_path__ + "r-v3/img/language_white.fdfe27ef.svg";